import { Step, StepLabel } from "@mui/material";
import { StepperIconComponent } from "@zenith/components";
import {
  SignUpPersonalDetailsPage,
  SignUpZenithAccountPage,
  SignUpPhotoVerificationPage,
  SignUpBusinessInformationPage,
} from "@zenith/pages";
import { SignUpSteps } from "./types";

const stepElement = (label: string, index: number) => {
  return (
    <Step key={label + index}>
      <StepLabel
        StepIconComponent={(props) => StepperIconComponent({ ...props })}
        sx={{
          "& .MuiStepLabel-label.Mui-completed": {
            color: "#6EBD7F !important", // circle color (COMPLETED)
          },
          "& .MuiStepLabel-label.Mui-disabled": {
            color: "#9B9B9B !important", //
          },
        }}
      >
        {label}
      </StepLabel>
    </Step>
  );
};

/**
 * * Creates and sets each signup step
 */

/**
 * default signup
 */

export const outletForDefault = (activeStep: number): JSX.Element => {
  switch (activeStep) {
    case 0:
      return <SignUpPersonalDetailsPage />;
    case 1:
      return <SignUpPhotoVerificationPage />;
    case 2:
      return <SignUpBusinessInformationPage />;
    default:
      throw new Error("Wrong active step");
  }
};

export const stepDefault = (steps: Array<{ stepName: SignUpSteps }>) => {
  return steps.map((step, index) => {
    const stepName = step.stepName;
    return stepElement(stepName, index);
  });
};

/**
 * mismatch signup
 */

export const outletForMismatch = (activeStep: number): JSX.Element => {
  switch (activeStep) {
    case 0:
      return <SignUpPersonalDetailsPage />;
    case 1:
      return <SignUpPhotoVerificationPage />;
    case 2:
      return <SignUpBusinessInformationPage />;
    default:
      throw new Error("Wrong active step");
  }
};

export const stepMismatch = (steps: Array<{ stepName: SignUpSteps }>) => {
  return steps.map((step, index) => {
    const stepName = step.stepName;
    return stepElement(stepName, index);
  });
};

/**
 * registered business signup (SOLE_PROPRIETORSHIP etc.) — same outlets as default, business sidebar labels
 */

export const stepBusiness = (steps: Array<{ stepName: SignUpSteps }>) => {
  return steps.map((step, index) => stepElement(step.stepName, index));
};

/**
 * existing account signup
 */

export const outletForExistingAccount = (activeStep: number): JSX.Element => {
  switch (activeStep) {
    case 0:
      return <SignUpZenithAccountPage />;
    case 1:
      return <SignUpPhotoVerificationPage />;
    case 2:
      return <SignUpBusinessInformationPage />;
    default:
      throw new Error("Wrong active step");
  }
};

export const stepExistingAccount = (
  steps: Array<{ stepName: SignUpSteps }>
) => {
  return steps.map((step, index) => {
    const stepName = step.stepName;
    return stepElement(stepName, index);
  });
};
